export const FormItemType = {
  AsyncSelect: 'asyncSelect',
  Button: 'button',
  CardNumber: 'cardNumber',
  Checkbox: 'checkbox',
  Code: 'code',
  DatePicker: 'datepicker',
  DateRange: 'daterange',
  Email: 'email',
  Expire: 'expire',
  HoldersDeviceSelect: 'holdersDeviceSelect',
  IP: 'ip',
  Iban: 'iban',
  Number: 'number',
  Password: 'password',
  RadioGroup: 'radiogroup',
  Row: 'row',
  Select: 'select',
  Switch: 'switch',
  Text: 'text',
  TextArea: 'textarea',
  Wrapper: 'wrapper'
};
